export default "__VITE_ASSET__21884c7d__"